export const SET_HOTEL_ACCOMMODATION = 'ROOMLIST/SET_HOTEL_ACCOMMODATION'
export const SET_HOTEL_ACCOMMODATIONS = 'ROOMLIST/SET_HOTEL_ACCOMMODATIONS'
